module.exports = __webpack_public_path__ + "media/about/kenneth-harmon-182cdebf.jpg";